import React from 'react';

function ProductFooter() {
  return (
    <footer className="ppfoot">
      <div className="pp-container ppfoot__inner">
        <div className="ppfoot__top">
          <div className="ppfoot__brand">
            <span className="ppfoot__brand-name">Samantha de Nicola</span>
            <span className="ppfoot__brand-role">Product Design &amp; Strategy</span>
          </div>
          <div className="ppfoot__links">
            <a href="mailto:sami@samidenicola.com" className="ppfoot__link">sami@samidenicola.com</a>
            <a href="https://www.linkedin.com/in/samidenicola/" target="_blank" rel="noopener noreferrer" className="ppfoot__link">LinkedIn ↗</a>
          </div>
        </div>

        <hr className="pp-rule" />

        <div className="ppfoot__bottom">
          <span className="ppfoot__meta">Currently Los Angeles · Open to NYC</span>
          <span className="ppfoot__meta">© {new Date().getFullYear()} Samantha de Nicola</span>
        </div>
      </div>
    </footer>
  );
}

export default ProductFooter;
